import Rails from "@rails/ujs"
import {Turbo} from "@hotwired/turbo-rails"

import $ from 'jquery'
window.jQuery = $
window.$ = $
require("jquery-blockui")

import "channels"
Rails.start ()
Turbo.session.drive = false
Turbo.start ()

import 'animate.css'
import "@fortawesome/fontawesome-free/css/all"
import "font-awesome/scss/font-awesome.scss"
import 'css/icon-simpleline/scss/simple-line-icons'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import "wowjs/css/libs/animate"
import toastr from 'toastr'
import 'toastr/toastr.scss'
window.toastr = toastr
import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap;

//= require i18n
//= require i18n.js
//= require i18n/translations
import I18n from 'i18n-js'

require ('../i18n/translation')
window.I18n = I18n

import "controllers"

$ (document).on ('turbolinks:load', () => {
    let locale = $ ('body').data ('locale');
    I18n.defaultLocale = locale
    I18n.locale = locale
})

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim ());
}
